const InviteEventWebPageEmailTypeEnum = {
  Invitation: 'Invitation',
  InvitationTickets: 'InvitationTickets',
  Custom: 'Custom',
};

export default Object.freeze(InviteEventWebPageEmailTypeEnum);
